/**
 * 購入方法選択画面のエラーメッセージ定義
 * エラー識別子に応じたユーザー向けメッセージを返す
 */

const SELECT_PAYMENT_METHOD_ERROR_MESSAGES = {
  system_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  temporary_error: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  unknown_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  not_registered: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  paypay_error: 'PayPayとの接続に問題が発生しました。時間をおいて再度お試しください。',
}

const DEFAULT_SELECT_PAYMENT_METHOD_ERROR_MESSAGE = '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。'

/**
 * 購入方法選択画面用: エラー識別子からエラーメッセージを取得
 * @param {string} errorIdentifier - APIから返されるエラー識別子
 * @returns {string} ユーザー向けエラーメッセージ
 */
export const getSelectPaymentMethodErrorMessage = (errorIdentifier) => {
  return SELECT_PAYMENT_METHOD_ERROR_MESSAGES[errorIdentifier] || DEFAULT_SELECT_PAYMENT_METHOD_ERROR_MESSAGE
}
